import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query BillingZuoraSoldToContact($businessId: ID!) {
    billingZuoraSoldToContact(businessId: $businessId) {
      contact {
        firstName
        lastName
        email
        telephone
        soldToIsBillTo
      }
      invalid
      invalidReasons
    }
  }
`

export const billingZuoraSoldToContactKey = getQueryNames(query)[0]
export default query
